import React, { useState } from 'react';
import Appearance from 'styles/Appearance.js';
import Button from 'views/Button.js';
import Utils from 'files/Utils.js';
import ConsultationModal from 'views/ConsultationModal.js';

const Consultation = ({ utils }) => {

    const [modalOpen, setModalOpen] = useState(false);

    const steps = [
        {
            icon: 'fas fa-pen',
            title: 'Share a few details',
            text: 'Tell us a little about your home and the best way to reach you.',
        },
        {
            icon: 'fas fa-handshake',
            title: 'A local dealer reaches out',
            text: 'An authorized Aqua Link dealer connects with you to talk through coverage.',
        },
        {
            icon: 'fas fa-sliders-h',
            title: 'A plan built for you',
            text: 'Get a protection plan tailored to your home — on your schedule.',
        },
    ];

    return (
        <section id={'consultation'} style={{
            width: '100%',
            backgroundColor: Appearance.colors.offWhite,
        }}>
            <div style={{
                maxWidth: Appearance.layout.maxWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
            }}>
                <div style={{
                    backgroundColor: Appearance.colors.white,
                    borderRadius: 24,
                    padding: Utils.isMobile() ? '44px 24px' : '72px 64px',
                    position: 'relative',
                    overflow: 'hidden',
                }}>
                    {/* Decorative accent */}
                    <div style={{
                        position: 'absolute',
                        top: -80,
                        right: -80,
                        width: 280,
                        height: 280,
                        borderRadius: '50%',
                        backgroundColor: Utils.hexToRGBA(Appearance.colors.primary(), 0.08),
                        pointerEvents: 'none',
                    }} />

                    <div style={{ position: 'relative' }}>
                        {/* Header */}
                        <div style={{
                            textAlign: 'center',
                            maxWidth: 680,
                            margin: '0 auto',
                            marginBottom: Utils.isMobile() ? 36 : 56,
                        }}>
                            <span style={{
                                ...Appearance.textStyles.label(),
                                display: 'block',
                                marginBottom: 14,
                            }}>
                                {'Authorized Local Dealer'}
                            </span>
                            <h2 style={{
                                ...Appearance.textStyles.sectionHeading(),
                                marginBottom: 16,
                            }}>
                                {'Not sure what your home needs?'}
                                <br />
                                {'Get matched with a local dealer.'}
                            </h2>
                            <p style={Appearance.textStyles.sectionSubheading({
                                margin: '0 auto',
                            })}>
                                {'Connect with an authorized Aqua Link dealer in your area. They’ll reach out to learn about your home and recommend the right coverage through a no cost, no obligation inspection.'}
                            </p>
                        </div>

                        {/* Steps */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: Utils.isMobile() ? '1fr' : 'repeat(3, 1fr)',
                            gap: Utils.isMobile() ? 24 : 32,
                            marginBottom: Utils.isMobile() ? 36 : 56,
                        }}>
                            {steps.map((step, index) => (
                                <div key={index} style={{
                                    ...Appearance.styles.card(),
                                    boxShadow: Appearance.boxShadow.card,
                                    padding: Utils.isMobile() ? 24 : 28,
                                }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                                        <i className={step.icon} style={{ fontSize: 19, color: Appearance.colors.primary(), flexShrink: 0 }} />
                                        <h3 style={{ ...Appearance.textStyles.subHeading({ fontSize: 18 }), margin: 0 }}>
                                            {step.title}
                                        </h3>
                                    </div>
                                    <p style={Appearance.textStyles.body({ fontSize: 15 })}>
                                        {step.text}
                                    </p>
                                </div>
                            ))}
                        </div>

                        {/* CTA */}
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 14,
                        }}>
                            <Button
                                label={'Connect With a Local Dealer'}
                                type={'primary'}
                                icon={'fas fa-handshake'}
                                onClick={() => setModalOpen(true)}
                                style={{ padding: '16px 40px', fontSize: 16 }} />
                            <span style={Appearance.textStyles.caption()}>
                                {'No obligation • Takes under a minute'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <ConsultationModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                utils={utils}
                sourceType={'dealer_consultation'} />
        </section>
    );
};

export default Consultation;
